import {AbstractControl, ValidatorFn} from '@angular/forms';

export function priceMinimumValidator(min: number): ValidatorFn {
  return (control: AbstractControl) => {
    let value = control.value;
    if (typeof value === 'string') {
      value = value.replace(/,/g, '');
    }
    const num = parseFloat(value);
    if (num < min) {
      return { min: true };
    }
    return null;
  };
}
